$(document).on('click', '.open-menu', function(){
    $('#open-menu').toggleClass('active');
});